// src/services/apiConfig.js
import api from "./api";

export const setAuthToken = (token) => {
  if (token) {
    // CHANGE THIS LINE: Use 'Bearer' instead of 'JWT'
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    console.log("✅ Auth token SET in Axios defaults using BEARER.");
  } else {
    delete api.defaults.headers.common["Authorization"];
    console.log("❌ Auth token REMOVED from Axios defaults.");
  }
};
